import { render, staticRenderFns } from "./AcompanhamentoList.vue?vue&type=template&id=28eb0cd4"
import script from "./AcompanhamentoList.vue?vue&type=script&lang=js"
export * from "./AcompanhamentoList.vue?vue&type=script&lang=js"
import style0 from "./AcompanhamentoList.vue?vue&type=style&index=0&id=28eb0cd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports